<template>
  <v-dialog persistent v-model="get_dialogMain.dialog" :width="get_dialogMain.withWindows" justify-center>
      <v-card width="auto" tile>

          <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title><h3>{{get_dialogMain.title}}</h3></v-toolbar-title>
            <v-spacer/>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN"><v-icon>mdi-close</v-icon></v-btn>
          </v-toolbar>

          <v-card-text>
            <v-row dense class="pa-2">
                <v-col cols="12">
                    <DataTable :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
                </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-end>
                <v-btn color="error darken-1" depressed outlined @click="closeDialog" class="mr-3"> Cerrar </v-btn>
                <!--<v-btn color="success darken-1" depressed outlined @click="saveInsumo" class="mr-3"> Guardar </v-btn> -->
            </v-layout>
          </v-card-actions>

      </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import DataTable from '@/components/dataTableMain'
export default {
  name: 'dialogMain',
  props: ['model'],
  data: () => ({
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Insumo', value: 'descripcion.inventario.folio', class: 'black--text' },
          { text: 'Insumo', value: 'descripcion.inventario.descripcion.nombre', class: 'black--text' },
          { text: 'Cantidad', value: 'descripcion.cantidad', class: 'black--text' },
          { text: 'Fecha', value: 'created_at', class: 'black--text' },
          { text: '', value: 'ActionsLocal', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Pdf Salida', icon: 'mdi-clipboard-text', color: 'blue-grey lighten-1', action: 'PrintPdfSale', code: 'libre', hidden: '' }
        ]
      },
      footer: {
        paging: true
      }
    },
    movements: []
  }),
  components: {
    DataTable
  },
  mounted () {
    this.user = this.$cookies.get('user')
    this.table.body.data = this.model.item.last_movement.detalles
  },
  methods: {
    ...mapActions(['postUrlImportDataServerAction']),
    // ========== ========== ========== Acciones de la tabla ========== ========== ========== \\
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },
    PrintPdfSale (item) {
      const router = this.get_urls['insumos.pdf']
      this.postUrlImportDataServerAction({ url: router, data: item.item })
    },
    // ========== ========== ========== END Acciones de la tabla END ========== ========== ========== \\
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'SET_DATA_OBJECT', 'CLEAR_OBJECTS_MODEL']),
    closeDialog () {
      this.HIDDE_DIALOG_MAIN()
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_options', 'get_model', 'get_object'])
  },
  watch: {
    get_model (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'succes',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Registro agregado correctamente !!'
      })
      this.SET_DATA_OBJECT(val)
      this.CLEAR_OBJECTS_MODEL()
      this.closeDialog()
    }
  }
}
</script>
<style></style>
